import {useUser} from '@product-web/user'
import {useRegisterState} from '@product-web-features/register/use-register-state'

export const useHasIncompleteSignup = () => {
    const user = useUser()
    const [params] = useRegisterState()

    return (!user && params.activeRegisterType) || (user && !user.role && !user.company)
}
